import { getRudderstack } from '@ecomm/shared-window'

/**
 * A function to track tooltip click event in buil-my-system page to RudderStack
 */
export function trackBmsTooltip(sensor: string) {
  getRudderstack(r => r.track('bms_tooltip', { sensor }))
}
/*
 * A function to track shop now click events to RudderStack
 */
export function trackShopNow() {
  getRudderstack(r => r.track('shop_now'))
}

export function trackShopSeeDetails(see_details_product: string) {
  getRudderstack(r => r.track('shop_see_details', { see_details_product }))
}

export function trackShopNowExperimentControl() {
  getRudderstack(r => r.track('Shop_now_shop'))
}

export function trackShopNowExperimentVariant() {
  getRudderstack(r => r.track('Shop_now_BMS'))
}

/**
 * Track when user clicks on 'or build your own system' in the Hero Banner
 * ECP-14299
 */
export function trackHeroBmsClick() {
  getRudderstack(r => r.track('hero_bms_click'))
}
